import React, { useEffect, useState } from "react"

import Container from "semantic-ui-react/dist/commonjs/elements/Container/Container"
import ActionBar from "../components/core/ActionBar"
import Filter from "../components/core/Filter/Filter"
import VerificarAntecedentesListView from "../components/CheckProfile/Nacionals/VerificarAntecedentesListView"

import Pagination from "../components/core/Pagination"

import { useTranslation } from "react-i18next"

import API from "../common/API"
import { Card } from "react-bootstrap"
import AdminVerificarAntecedentesFilterFields from "../components/Admin/AdminVerificarAntecedentes.filterFields"

function IdentitiesPage() {
  const [page, setPage] = useState(0)
  const [quantity, setQuantity] = useState(20)
  const [totalPages, setTotalPages] = useState(1)

  const [records, setRecords] = useState<any>([])
  const [vehicleRecords, setVehicleRecords] = useState<any>([])
  const [filterValues, setFilterValues] = useState<any>({})

  const [filterFields] = useState(AdminVerificarAntecedentesFilterFields)
  const getFilterValues = obj => {
    setFilterValues(obj)
  }

  const { t } = useTranslation("global")
  const [isLoading, setIsLoading] = useState(false)

  const isVehicleSearch = (fv: any) =>
    fv && typeof fv.matriculaVin === "string" && fv.matriculaVin.trim().length > 0

  const onPageChanged = (obj: number) => {
    setPage(obj)
  }

  const bindDataRemote = async () => {
    try {
      setIsLoading(true)

      if (Object.keys(filterValues).length === 0) {
        return
      }

      if (isVehicleSearch(filterValues)) {
        const res = await API.postAction("Vehiculos/List", {
          VIN: filterValues.matriculaVin.trim(),
          Page: page,
          Quantity: quantity,
        })
        if (res.data.status === "ok") {
          setVehicleRecords(res.data.response)
          setTotalPages(res.data.quantityOfPages)
        }
        setRecords([])
        return
      }

      const queryParams = new URLSearchParams()
      queryParams.set("external", "false")
      Object.entries(filterValues).forEach(([key, value]) => {
        const textValue = `${value ?? ""}`.trim()
        if (textValue.length > 0) {
          queryParams.set(key, textValue)
        }
      })
      queryParams.set("page", `${page}`)
      queryParams.set("quantity", `${quantity}`)
      let request = await API.getAction("busqueda/nacionales?" + queryParams.toString())
      if (request.data.status === "ok") {
        setRecords(request.data.response)
        setTotalPages(request.data.quantityOfPages)
      }
      setVehicleRecords([])
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    bindDataRemote()
  }, [page])

  useEffect(() => {
    if (Object.keys(filterValues).length === 0) {
      setPage(0)
      setRecords([])
      setVehicleRecords([])
      return
    }
    if (filterValues) {
      setPage(0)
      setTimeout(() => {
        bindDataRemote()
      }, 500)
    }
  }, [filterValues])

  return (
    <Container>
      <ActionBar
        title={t("Identidades")}
        actions={<div className="ms-2 btn-group"></div>}
      />

      <div className="my-4">
        <Filter
          title={t("Verificar Por:")}
          fields={filterFields}
          setFilterFields={getFilterValues}
          filterAction={() => {
            bindDataRemote()
          }}
        />
      </div>

      {isLoading && (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {isVehicleSearch(filterValues) ? (
        <Card className="mb-4">
          <Card.Body className="p-0">
            <div className="table-responsive">
              {vehicleRecords && vehicleRecords.length > 0 ? (
                <table className="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Matrícula</th>
                      <th>VIN</th>
                      <th>Vehículo</th>
                      <th>Estado</th>
                      <th>Propietario</th>
                      <th>Fecha Registro</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehicleRecords.map((v: any, i: number) => (
                      <tr key={i}>
                        <td><b>{v.matricula}</b></td>
                        <td className="text-muted" style={{ fontSize: "0.85em" }}>{v.vin}</td>
                        <td>
                          {[v.marca, v.modelo, v.anio, v.color].filter(Boolean).join(" · ")}
                          {v.tipoVehiculo && <><br /><small className="text-muted">{v.tipoVehiculo}</small></>}
                        </td>
                        <td>
                          {v.estado && <span className="badge bg-secondary">{v.estado}</span>}
                          {v.estadoTransferencia && (
                            <><br /><small className="text-muted">{v.estadoTransferencia}</small></>
                          )}
                        </td>
                        <td>
                          <b>{v.nombrePropietario}</b>
                          {v.cedulaPropietario && <><br /><small>{v.cedulaPropietario}</small></>}
                          {v.direccion && <><br /><small className="text-muted">{v.direccion}</small></>}
                        </td>
                        <td>{v.fechaRegistroPlaca}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                !isLoading && (
                  <div className="text-center py-4">
                    <h3>{t("No records found")}</h3>
                  </div>
                )
              )}
            </div>
          </Card.Body>
        </Card>
      ) : (
        <VerificarAntecedentesListView
          records={records}
          admin={true}
          backgroundCheck={false}
          isLoading={isLoading}
        />
      )}

      <Card className="mb-4">
        <Card.Body className="p-0 pt-2">
          <Pagination
            totalPages={totalPages}
            currentPage={page}
            onPageChanged={onPageChanged}
          />
        </Card.Body>
      </Card>
    </Container>
  )
}

export default IdentitiesPage
